import * as React from "react";
import { Button, Grid, Stack } from "@mui/material";
import styled from "styled-components";
import { Link as RouteLink, useNavigate } from "react-router-dom";
import TourIcon from "@mui/icons-material/Tour";
import MissionCard from "src/scenes/dashboard/overview-components/mission-card";

const SectionTitle = styled.h2`
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    margin: 0;
`;

const MissionsHistoryTeamsLink = styled(RouteLink)`
    font-size: 12px;
    font-weight: 300;
    line-height: 20px;
    font-style: normal;
    color: ${({ theme }) => theme.palette.text.primary};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
`;

const DashboardButton = styled(Button)`
    background-color: ${({ theme }) => theme.palette.background.default};
    font-size: 12px;
    margin-top: 13px;
    z-index: 10;
`;

const MissionsAccordion = ({
    isMissionsDeleteModalOpen,
    setIsMissionsDeleteModalOpen,
    setToDeleteId,
    setToDeleteKey,
    activeMissions,
    teamId,
    teamName,
    isDemo,
}) => {
    const navigate = useNavigate();

    const redirectToTeamMissions = () => {
        return navigate("/missions-teams", {
            state: { teamId, teamName },
        });
    };

    const renderActiveMissions = () => {
        const data = activeMissions || [];

        return data.map((mission) => (
            <Grid item justifyContent="space-evenly">
                <MissionCard
                    title={mission.title}
                    completion={mission.currentProgressPercentage}
                    progress={mission.currentProgress}
                    goal={mission.description}
                    target={mission.target}
                    targetComparison={mission.targetComparison}
                    startDate={mission.startDate}
                    endDate={mission.endDate}
                    missionId={mission.missionId}
                    handleDeleteModal={() => {
                        setIsMissionsDeleteModalOpen(!isMissionsDeleteModalOpen);
                        setToDeleteId(mission.missionId);
                        setToDeleteKey(mission.missionKey);
                    }}
                />
            </Grid>
        ));
    };

    const renderNoMissionsPlaceholder = () => {
        const data = activeMissions || [];
        if (data && !data.length)
            return (
                <Stack>
                    <p>No ongoing missions. Create a mission.</p>
                </Stack>
            );
        return null;
    };

    return (
        <div>
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
                style={{ width: "100%" }}
            >
                <SectionTitle>Missions</SectionTitle>
                <Stack direction="row" alignItems="center" spacing={1}>
                    {teamId && !isDemo ? (
                        <MissionsHistoryTeamsLink
                            teamId={teamId}
                            to={`/teams/${teamId}/missions-history`}
                        >
                            Missions History
                        </MissionsHistoryTeamsLink>
                    ) : (
                        <MissionsHistoryTeamsLink teamId={teamId} to="/missions-history">
                            Missions History
                        </MissionsHistoryTeamsLink>
                    )}
                    {teamId && !isDemo ? (
                        <DashboardButton
                            variant="outlined"
                            color="secondary"
                            onClick={(e) => {
                                e.stopPropagation();
                                redirectToTeamMissions();
                            }}
                            startIcon={<TourIcon />}
                            style={{
                                textDecoration: "auto",
                                textAlign: "center",
                                paddingRight: "12px",
                            }}
                        >
                            create mission
                        </DashboardButton>
                    ) : (
                        <DashboardButton
                            variant="outlined"
                            color="secondary"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            component={RouteLink}
                            startIcon={<TourIcon />}
                            to="/missions-personal"
                            style={{
                                textDecoration: "auto",
                                textAlign: "center",
                                paddingRight: "12px",
                            }}
                        >
                            create mission
                        </DashboardButton>
                    )}
                </Stack>
            </Stack>
            {renderNoMissionsPlaceholder()}
            <Grid container direction="row" spacing={2}>
                {renderActiveMissions()}
            </Grid>
        </div>
    );
};

export default MissionsAccordion;
